module.exports = __webpack_public_path__ + "img/img_title_advantage_04.a4f4b290.png";